import jwt_decode from "jwt-decode";

export const checkLukeContentRole = roles => {
  return roles.some(role => role.Name === "LukeContentQA");
};

export const checkContentAdminRole = roles => {
  return roles.some(role => role.Name === "ContentAdmin");
};

const portals = [
  {
    id: 1,
    name: "LukeContentQA",
    roleChecker: checkLukeContentRole,
  },
  {
    id: 2,
    name: "ContentAdmin",
    roleChecker: checkContentAdminRole,
  },
];

// for QA and Content permission
export const checkQAContentRole = access_token => {
  if (!access_token) return false;
  const decoded = jwt_decode(access_token);
  const { role } = decoded;
  const roles = JSON.parse(role);
  return portals.some(portal => portal.roleChecker(roles) === true);
};

// for Luke only permission
export const checkLukeRole = access_token => {
  if (!access_token) return false;
  const decoded = jwt_decode(access_token);
  const { role } = decoded;
  const roles = JSON.parse(role);
  return checkLukeContentRole(roles);
};

// for Content only permission
export const checkContentRole = access_token => {
  if (!access_token) return false;
  const decoded = jwt_decode(access_token);
  const { role } = decoded;
  const roles = JSON.parse(role);
  return checkContentAdminRole(roles);
};
